import React, {useEffect, useState } from 'react'
import "./AdProductDetails.css"
import './CheckoutProduct.css'
import dataCarts from './dataCarts'
import { useStateValue } from './StateProvider';
import axios from 'axios';
import CurrencyFormat from 'react-currency-format';
import { useHistory } from 'react-router-dom';

function AdProductDetails() {
  const [{ basket, productDetalis }, dispatch] = useStateValue();
  const [product, setProduct] = useState([]);
  const [id, setId] = useState('')
  const [title, setTitle] = useState('');
  const [price, setPrice] = useState('');
  const [img, setImg] = useState('');
  const [weigth, setWeigth] = useState('');
  const [dimensions, setDimensions] = useState('');
  const [searching_words, setSearching_words] = useState('');
  const history = useHistory();
  var matchcount = 0;

  const hedit = () =>{
    history.push('/admin-product-edit');
  }

  const hclose = () => {
    history.push('/Admin14F-efghS=workApp/filesManagement-Wdf17/Admin');
  }

  useEffect(() => {
    productDetalis.map(item =>{
      setId(item.id)
      setTitle(item.title)
      setPrice(item.price)
      setImg(item.img);
      setSearching_words(item.searching_words)

      axios
          .get('https://toycityzimbabwe.com/backend/getSpecs.php', {params: {name: item.title}})
          .then(res => {
            setProduct(res.data)
          })
          .catch( error => {
              console.log(error)
          });
    })

    dispatch({
      type: 'SET_ADMNO',
      admnavagationoption: 'two'
    })
    
      
  }, []);

  useEffect(() => {
    product.map(item => {
      setWeigth(item.pdescription);
      setDimensions(item.dimension);
    })
    
  }, [product])

  const [slideIndex, setSlideIndex] = useState(1);

  useEffect(() => {
    const lastIndex = dataCarts.length
    
    if(slideIndex < 1){
        setSlideIndex(lastIndex)
    }

    if( slideIndex > lastIndex){
        setSlideIndex(1)
    }
  }, [slideIndex])

  useEffect(() => {
    let slider = setInterval(() => {
        setSlideIndex(slideIndex + 1)
    }, 5000);
    return () => clearInterval(slider)
  }, [slideIndex])

  const moveDot = index => {
    setSlideIndex(index)
  }

  return (
    <div className="container-carts">
        <div className="container-btn">
            <button className='x-btn' onClick={hclose}>X</button>
        </div>
      <div className='details-cont'>
        {product.map((obj, index) => {
          
              return (
                  <div
                  key={obj.id}
                  className={slideIndex === index + 1 ? "slide active-anim" : "slide"}
                  >
                      <img 
                        src={obj.product_img} 
                      />
                  </div>
                )
          })}
          <div className="container-cartdots">
            {product.map((item, index) => (
                <div 
                  onClick={() => moveDot(index + 1)}
                  className={slideIndex === index + 1 ? "cartdot active" : "cartdot"}
                  
                >
                  <img 
                        src={item.product_img} 
                  />
                </div>
            ))}
          </div>
      </div>
      
      <div className='carts-details'>
          <p>{title}</p>
          <h2><div className='price-display'>
                <CurrencyFormat
                    renderText={(value) => (
                        <>
                            <h3>{value}</h3>
                        </>
                    )}
                    decimalScale={2}
                    value={price}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                />
            </div></h2>
      </div>
      <h3>Specifications</h3>
      <div className='specs-cont'>
        <table>
          <tr>
            <th>Description:</th>
            <td>{weigth}</td>
          </tr> 
          <tr> 
            <th>Dimensions:</th>
            <td>{dimensions}</td>
          </tr>
          <tr> 
            <th>Searching:</th>
            <td>{searching_words}</td>
          </tr>
        </table>  
      </div>
      <div className="container-btn">
        <button className='c-btn' onClick={hedit}>Edit</button>
      </div>
    </div>
  )
}

export default AdProductDetails;